module.exports = __webpack_public_path__ + "img/AuthenticLabs.b0920a34.svg";